export const getGoogleSlidesId = (value: string) => {
  const array = value.split("/");
  const indexOfD = array.indexOf("d");
  return array[indexOfD + 1];
};
